module.exports = __webpack_public_path__ + "img/home-world-best-banner-04-on.9fedbb09.jpg";